/**
 * Taux NORMAL de TVA suisse par année (décimal ; source AFC).
 * Sert de défaut pour la méthode effective : les taux légaux s'appliquent
 * automatiquement, l'utilisateur ne saisit que s'il est sur un taux différent
 * (ex. hébergement 3,8 % pour un hôtelier, taux réduit 2,6 %).
 *   - dès 2024 : 8,1 %
 *   - 2018–2023 : 7,7 %
 *   - 2011–2017 : 8,0 %
 *   - avant 2011 : 7,6 %
 * Le TDFN n'a pas de barème légal (taux de branche accordé par l'AFC) → pas de défaut.
 */
export function legalNormalVatRate(year) {
  const y = Number(year);
  if (!Number.isFinite(y)) return null;
  if (y >= 2024) return 0.081;
  if (y >= 2018) return 0.077;
  if (y >= 2011) return 0.08;
  return 0.076;
}
